import type { Edition } from '../../../calculator/types';

export interface ProductCardEditionOption {
	value: Edition;
	label: string;
}

export const EDITIONS: ProductCardEditionOption[] = [
	{ value: 'free', label: 'Free' },
	{ value: 'standard', label: 'Standard' },
	{ value: 'premium', label: 'Premium' },
	{ value: 'enterprise', label: 'Enterprise' },
];
